import { PackageModel } from "../repositories/package.repository";

export type CurrencyCode =
  | "LAK"
  | "USD"
  | "THB"
  | "EUR"
  | "GBP"
  | "AUD"
  | "CNY";

interface CurrencyConfig {
  code: CurrencyCode;
  label: string;
  symbol: string;
  symbolPosition: "prefix" | "suffix";
  getAmount: (
    pkg: Pick<PackageModel, "price" | "currencies">,
  ) => number | string;
}

const foreignAmount =
  (code: Exclude<CurrencyCode, "LAK">) =>
  (pkg: Pick<PackageModel, "price" | "currencies">): number =>
    pkg.currencies[code] ?? 0;

export const CURRENCIES: Record<CurrencyCode, CurrencyConfig> = {
  LAK: {
    code: "LAK",
    label: "LAK",
    symbol: "₭",
    symbolPosition: "prefix",
    getAmount: (pkg) => pkg.price,
  },
  USD: {
    code: "USD",
    label: "USD",
    symbol: "$",
    symbolPosition: "prefix",
    getAmount: foreignAmount("USD"),
  },
  THB: {
    code: "THB",
    label: "THB",
    symbol: "฿",
    symbolPosition: "prefix",
    getAmount: foreignAmount("THB"),
  },
  EUR: {
    code: "EUR",
    label: "EUR",
    symbol: "€",
    symbolPosition: "prefix",
    getAmount: foreignAmount("EUR"),
  },
  GBP: {
    code: "GBP",
    label: "GBP",
    symbol: "£",
    symbolPosition: "prefix",
    getAmount: foreignAmount("GBP"),
  },
  AUD: {
    code: "AUD",
    label: "AUD",
    symbol: "A$",
    symbolPosition: "prefix",
    getAmount: foreignAmount("AUD"),
  },
  CNY: {
    code: "CNY",
    label: "CNY",
    symbol: "¥",
    symbolPosition: "prefix",
    getAmount: foreignAmount("CNY"),
  },
};

export const SUPPORTED_CURRENCIES: CurrencyCode[] = [
  "LAK",
  "USD",
  "THB",
  "EUR",
  "GBP",
  "AUD",
  "CNY",
];

export const formatPackagePrice = (
  pkg: Pick<PackageModel, "price" | "currencies">,
  currency: CurrencyCode,
): string => {
  const cfg = CURRENCIES[currency];
  const amount = Number(cfg.getAmount(pkg));

  if (currency === "LAK") {
    return `${cfg.symbol}${amount.toLocaleString("en-US")}`;
  }

  return `${cfg.symbol}${amount.toFixed(2)}`;
};
